import React from "react";
import { EditButton, TopToolbar, useResourceDefinition, useShowController, useTranslate } from "react-admin";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { grey as Grey } from "@mui/material/colors";

const commonStyles = {
  link: {
    color: Grey["600"],
    fontSize: "14px",
    textDecoration: "underline",
    verticalAlign: "sub",
  },
};

export const ShowToolbar = (props: { children?: any; listPath: string }) => {
  const { record, resource } = useShowController();
  const { hasEdit } = useResourceDefinition();
  const translate = useTranslate();

  if (!record) {
    return null;
  }

  const { pathname } = window.location;

  return (
    <TopToolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        <Box>
          <Link sx={commonStyles.link} href={`${pathname}#${props.listPath}`}>
            {translate("ui.action.back_to_list")}
          </Link>
        </Box>
        <Box textAlign="right">
          {props.children ? props.children : hasEdit && <EditButton resource={resource} record={record} />}
        </Box>
      </Box>
    </TopToolbar>
  );
};
